export default "__VITE_ASSET__DSWDVSop__"